import { render, staticRenderFns } from "./designerDetail.vue?vue&type=template&id=440c0d48&scoped=true&"
import script from "./designerDetail.vue?vue&type=script&lang=js&"
export * from "./designerDetail.vue?vue&type=script&lang=js&"
import style0 from "./designerDetail.vue?vue&type=style&index=0&id=440c0d48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440c0d48",
  null
  
)

export default component.exports